import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { IbanFormControl } from './iban-form-control';

@Component({
    selector: 'app-iban-form-control',
    templateUrl: './iban-form-control.component.html',
    styleUrls: ['./iban-form-control.component.scss']
})
export class IbanFormControlComponent extends AbstractFormControlComponent<IbanFormControl> {
    @Input() parentForm: FormGroup;
    @Input() title: string;
    @Input() controlName: string;
    @Output() onChange: EventEmitter<any> = new EventEmitter();

    faCheck: any = faCheck;
    faClose: any = faTimes;

    change(): void {
        this.onChange.emit(this.control.value);
    }

    public get readOnlyCss(): boolean {
        return this.control.readOnlyCss || false;
    }
}
